export default __webpack_public_path__ + "static/media/background.f1d2e786.png";